/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  PostApiV1SsoimageMutationRequest,
  PostApiV1SsoimageMutationResponse,
  PostApiV1Ssoimage400,
  PostApiV1Ssoimage401,
  PostApiV1Ssoimage500,
} from "../../types/SSOImageController/PostApiV1Ssoimage.ts";

function getPostApiV1SsoimageUrl() {
  const res = { method: "POST", url: `/api/v1/ssoimage` as const };
  return res;
}

/**
 * @description Cria uma nova SSOImage com seus idiomas. O conteúdo de cada idioma é salvo no Azure Blob Storage antes da confirmação no banco. **(Requer Authorization para autenticação)**
 * @summary Criar imagem SSO (Requer Authorization para autenticação)
 * {@link /api/v1/ssoimage}
 */
export async function postApiV1Ssoimage(
  data: PostApiV1SsoimageMutationRequest,
  config: Partial<RequestConfig<PostApiV1SsoimageMutationRequest>> & {
    client?: Client;
  } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    PostApiV1SsoimageMutationResponse,
    ResponseErrorConfig<
      PostApiV1Ssoimage400 | PostApiV1Ssoimage401 | PostApiV1Ssoimage500
    >,
    PostApiV1SsoimageMutationRequest
  >({
    method: "POST",
    url: getPostApiV1SsoimageUrl().url.toString(),
    data: requestData,
    ...requestConfig,
    headers: { "Content-Type": "application/*+json", ...requestConfig.headers },
  });
  return res.data;
}
